export const onWindowUnload = (callback: (e: Event) => void) => {
  window.addEventListener('pagehide', (e: PageTransitionEvent) => {
    if (!e.persisted) {
      callback(e)
    }
  })
}
